import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const TestimonialsBlock = ({
  key,
  heading=null,
  link=null,
  linkText=null,
  spotlights=null,
  testimonials=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  let newObj = [];
  if (spotlights && spotlights.length > 0) {
    for (let i = 0; i < spotlights.length; i++) newObj.push(spotlights[i])
  }
  if (testimonials && testimonials.length > 0) {
    for (let i = 0; i < testimonials.length; i++) newObj.push(testimonials[i])
  }

  return (
    <div className=" customer_spotlight_block">
      <div className="container">
        {heading &&
          <div className="row">
            <div className="col-12 text-center mb2">
              <h2 className="module-header">{ htmlDecode(heading) }</h2>
            </div>
          </div>
        }
        {newObj.length === 1 && newObj.map((object, index) => (
          <div className="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2 testimonial-static ph0">
            <div className="d-flex flex-wrap">
              <div className={ `col-12 spotlight-inner ${object.featuredImage ? "col-md-7 pl0" : " "}` }>
                <div className="quotes">
                  {object.content &&
                    <div className="copy" dangerouslySetInnerHTML={{ __html: object.content }} />
                  }
                  {object.bio &&
                    <div className="copy" dangerouslySetInnerHTML={{ __html: object.bio }} />
                  }
                  <div className="cust-info">
                    {object.title &&
                      <span className="name">{ htmlDecode(object.title) }</span>
                    }
                    {object.positionTitle &&
                      <span className="position">{ htmlDecode(object.positionTitle) }</span>
                    }
                    <br />
                  </div>
                </div>
              </div>
              {object.featuredImage &&
              <div className="col-12 col-md-7 col-xl-4 offset-xl-1 cust-img-wrap">
                {object.featuredImage.formats?.small &&
                <img className="cust-img" src={object.featuredImage.formats.small.url.includes(cdnUrl) ? object.featuredImage.formats.small.url : cdnUrl + object.featuredImage.formats.small.url} alt={ object.featuredImage?.alternativeText } />
                }
                {!object.featuredImage.formats?.small &&
                <img className="cust-img" src={object.featuredImage.url.includes(cdnUrl) ? object.featuredImage.url : cdnUrl + object.featuredImage.url} alt={ object.featuredImage?.alternativeText } />
                }
              </div>
              }
            </div>

          </div>
        ))}
        {newObj.length > 1 &&
          <div className="col-12 col-xl-10 offset-xl-1 testimonial-slideshow">
            <div className="row">
              <div className="d-none d-sm-flex col-sm-1">
                <a className="carousel-control-prev" href="#testimonialSlideshow" role="button" data-slide="prev">
                  <span className="fas fa-angle-left" aria-hidden="true" />
                  <span className="sr-only">Previous</span>
                </a>
              </div>
              <div className="col-12 col-sm-10 ph0">
                <div className="d-flex">
                  <div id="testimonialSlideshow" className="testimonialSlideshow carousel slide" data-ride="carousel">
                    <div className="col-12 carousel-inner">
                      {newObj.length > 1 && newObj.map((object, index) => (
                        <div className={ `carousel-item ${!index ? "active" : ""}` }>
                          <div className={`row flex-xl-row flex-xl-nowrap`}>
                            <div className={ `col-12 spotlight-inner ${object.featuredImage ? "col-md-6 pl0" : ""}` }>
                              <div className={ `quotes ${object.featuredImage ? "pl0" : ""}` }>
                                {object.bio &&
                                <div className="copy" dangerouslySetInnerHTML={{ __html: object.bio }} />
                                }
                                <div className="cust-info">
                                  {object.title &&
                                  <span className="name">{ htmlDecode(object.title) }</span>
                                  }
                                  {object.positionTitle &&
                                  <span className="position">{ htmlDecode(object.positionTitle) }</span>
                                  }
                                  <br />
                                </div>
                              </div>
                            </div>
                            {object.featuredImage &&
                            <div className="col-12 col-md-6 cust-img-wrap">
                              {object.featuredImage?.formats?.medium &&
                              <img className="cust-img" src={object.featuredImage.formats.medium.url.includes(cdnUrl) ? object.featuredImage.formats.medium.url : cdnUrl + object.featuredImage.formats.medium.url} alt={ object.featuredImage?.alternativeText } />
                              }
                              {!object.featuredImage?.formats?.medium &&
                              <img className="cust-img" src={object.featuredImage.url.includes(cdnUrl) ? object.featuredImage.url : cdnUrl + object.featuredImage.url} alt={ object.featuredImage?.alternativeText } />
                              }
                            </div>
                            }
                          </div>
                          </div>
                      ))}
                    </div>
                    <ol className="carousel-indicators col-12 col-lg-6">
                      {newObj.length > 1 && newObj.map((object, index) => (
                        <li data-target="#testimonialSlideshow" data-slide-to={ index } className={ `${!index ? "active" : ""}` }>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              </div>
              <div className="d-none d-sm-flex col-sm-1">
                <a className="carousel-control-next" href="#testimonialSlideshow" role="button" data-slide="next">
                  <span className="fas fa-angle-right" aria-hidden="true" />
                  <span className="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>
        }
        {link && linkText &&
          <div className="buttons col-12 tac mt3">
            <Link href={ link } className="button uppercase" title={ linkText }>{ linkText }</Link>
          </div>
        }
      </div>
    </div>
  )
}

export default TestimonialsBlock
